import { Controller } from "@hotwired/stimulus"
import { get, post, put, patch, destroy } from "@rails/request.js"
import Sortable from "../vendor/sortable.esm.min.js"

// Connects to data-controller="zielsort"
export default class extends Controller {
	static targets = ["zielSortFormular"]

  	connect() {
		this.sortable = new Sortable(this.element, {
			animation: 150,
			handle: ".sort-element",
			onEnd: () => this.updateZielreihenfolge()
		})
	}

	disconnect() {
		this.sortable?.destroy()
	}

	updateZielreihenfolge() {
		this.zielSortFormularTargets.forEach((zielForm, index) => {
		const positionField = zielForm.querySelector(".position_field")
		const newZielPosition = index + 1
		// Wenn im Hidden-Field nicht die neue/richtige Position steht:
		// -> Setze die neue Position ins Hidden-Field + sende update
		if (positionField.value != newZielPosition) {
			positionField.value = newZielPosition
			this.sendRequest(zielForm.action, new FormData(zielForm));
		}
		})
	}

	sendRequest(url, formData) {
		patch(url, { responseKind: "turbo-stream", body: formData })
	}

}
